import HostSearchStore, { IHostSearch } from 'stores/host/HostSearchStore';
import BaseSearchListStore from 'stores/BaseSearchListStore';
import { SortDirection } from 'constants/SortDirection';

export default class HostSearchListStore extends BaseSearchListStore<HostSearchStore> {
    baseRoute = 'hosts';

    constructor() {
        super({
            itemStore: HostSearchStore,
            sortBy: 'created_on',
            sortDirection: SortDirection.ASC
        });
    }

    public get instances(): (IHostSearch | undefined)[] {
        return this.ids.map((id) => {
            const itemStore = this.data.get(id);

            if (itemStore) {
                return {
                    ...itemStore.hostSearch,
                    store: itemStore
                };
            }
        });
    }
}
